module.exports = __webpack_public_path__ + "img/cowise3.d720a6c5.png";